import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import Price from '../Price.js';

const PricePerLiter = (_param)=>{
    var { amount , currencyCode , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "amount",
        "currencyCode",
        "className"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("span", swcHelpers.extends({
        className: classnames('price-per-liter', className)
    }, rest), /*#__PURE__*/ React.createElement(Price, {
        value: amount,
        currency: currencyCode,
        centAmount: false
    }), "/", getLabel('products.unit.metric.liter.abbr'));
};
var PricePerLiter$1 = PricePerLiter;

export { PricePerLiter$1 as default };
//# sourceMappingURL=PricePerLiter.js.map
